// Варианты для новости с галочкой «Это мероприятие»: те же, что в форме
// мероприятия, плюс пустой — у новости формат и место необязательны
export const EVENT_FORMAT_OPTIONS = [
    { value: '', label: 'Не указан' },
    { value: 'ON', label: 'Онлайн' },
    { value: 'OF', label: 'Офлайн' },
];

export const EVENT_ADDRESS_OPTIONS = [
    { value: '', label: 'Не указано' },
    { value: 'Юридический факультет МГУ', label: 'Юридический факультет МГУ' },
    { value: 'Сторонняя организация', label: 'Сторонняя организация' },
];
